import { ObservationType } from './observation-type';

export class Observation {
  comment: string;
  id: number;
  modifiedOn: string;
  observationState: string = 'NEW';
  observationType: ObservationType;

  constructor(observationType?: ObservationType, comment?: string, id?: number, modifiedOn?: string) {
    this.id = id || null;
    this.observationType = observationType || null;
    this.comment = comment || '';
    this.modifiedOn = modifiedOn || null;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/observation.ts